import type { Department } from "@/types/department";

/** Department code for قسم الاعلام — pages here are always news articles. */
export const MEDIA_DEPARTMENT_CODE = "MEDIA";

export function departmentRequiresNewsPage(
  department: Pick<Department, "code"> | null | undefined,
): boolean {
  return department?.code === MEDIA_DEPARTMENT_CODE;
}
